import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import logoImg from '../assets/blast-logo.webp';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', phone: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/member-auth/register', form);
      localStorage.setItem('blast_member_token', res.data.token);
      localStorage.setItem('blast_member_info', JSON.stringify(res.data.member));
      document.cookie = `blast_logged_in_name=${encodeURIComponent(res.data.member.name)}; domain=.ridewithblast.com; path=/; max-age=2592000`;
      document.cookie = `blast_member_token=${res.data.token}; domain=.ridewithblast.com; path=/; max-age=2592000`;
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Gagal mendaftar. Coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#12151A', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: "'Segoe UI', sans-serif" }}>
      <div style={{ width: '100%', maxWidth: 400, background: '#1C2128', border: '1px solid #262b33', padding: 36, clipPath: 'polygon(0 0, 100% 0, 100% 96%, 96% 100%, 0 100%)' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <img src={logoImg} alt="Blast Motor Club" style={{ height: 56, width: 'auto' }} />
        </div>
        <p style={{ textAlign: 'center', color: '#8B92A0', fontSize: 13, marginBottom: 24, textTransform: 'uppercase', letterSpacing: 1 }}>
          Daftar Jadi Member
        </p>

        {error && (
          <div style={{ background: 'rgba(208,33,39,0.1)', border: '1px solid #D02127', color: '#D02127', padding: '10px 14px', borderRadius: 6, fontSize: 12, marginBottom: 16 }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <input
            type="text"
            placeholder="Nama Lengkap"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            required
            style={{ background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '12px 14px', color: '#F0EDE4', fontSize: 14 }}
          />
          <input
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
            style={{ background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '12px 14px', color: '#F0EDE4', fontSize: 14 }}
          />
          <input
            type="tel"
            placeholder="Nomor HP"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            style={{ background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '12px 14px', color: '#F0EDE4', fontSize: 14 }}
          />
          <input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
            minLength={6}
            style={{ background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: '12px 14px', color: '#F0EDE4', fontSize: 14 }}
          />
          <button
            type="submit"
            disabled={loading}
            style={{
              background: '#2B6996', color: '#fff', border: 'none', padding: 13, fontWeight: 800,
              fontSize: 14, textTransform: 'uppercase', letterSpacing: 1, cursor: 'pointer', marginTop: 6,
              clipPath: 'polygon(4% 0, 100% 0, 96% 100%, 0 100%)',
            }}
          >
            {loading ? 'Mendaftar...' : 'Daftar'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 13, color: '#8B92A0' }}>
          Sudah punya akun? <Link to="/login" style={{ color: '#2B6996', textDecoration: 'none', fontWeight: 700 }}>Masuk di sini</Link>
        </p>
      </div>
    </div>
  );
}
